import {useEffect, useState} from 'react'
import {MapContext} from '../context/MapContext'
import {servicesData} from "../data/services-data";
import {accessData} from "../data/access-data";
import {scenariesData} from "../data/scenaries-data";
import {zonesData} from "../data/zones-data";

const MapProvider = ({children}) => {
  // Map
  const [mapCoords, setMapCoords] = useState([25.680043, -100.281525, 0])

  // States
  const [featuredMarker, setFeaturedMarker] = useState(null)
  const [mapFocus, setMapFocus] = useState(null)
  const [routeTarget, setRouteTarget] = useState(null)
  const [isRouteReady, setIsRouteReady] = useState(false)
  const [showPanel, setShowPanel] = useState('close')
  const [listLayout, setListLayout] = useState('list')
  const [searchFilter, setSearchFilter] = useState('')

  // Data
  const [locations, setLocations] = useState([])

  // Settings
  const checkLocalStorage = (data) => {
    return data !== 'false';
  }

  const [showSettings, setShowSettings] = useState(false)
  const [servicesSetting, setServicesSetting] = useState(true)
  const [accessSetting, setAccessSetting] = useState(true)
  const [scenariesSetting, setScenariesSetting] = useState(true)
  const [currentLocation, setCurrentLocation] = useState(true)
  const [zonesSetting, setZonesSetting] = useState(false)

  useEffect(() => {
    // TODO: Cambiar por objeto
    setServicesSetting(checkLocalStorage(localStorage.getItem('servicesSetting')))
    setAccessSetting(checkLocalStorage(localStorage.getItem('accessSetting')))
    setScenariesSetting(checkLocalStorage(localStorage.getItem('scenariesSetting')))
    setCurrentLocation(checkLocalStorage(localStorage.getItem('currentLocation')))
    setZonesSetting(checkLocalStorage(localStorage.getItem('zonesSetting')))
  }, [])

  useEffect(() => {
    // Perdóname Diosito por esta validación, pero ya no había tiempo
    let wholeData = []
    setLocations(wholeData.concat(
      scenariesSetting ? scenariesData : [],
      servicesSetting ? servicesData : [],
      accessSetting ? accessData : [],
      zonesSetting ? zonesData : [],
    ))
  }, [servicesSetting, accessSetting, scenariesSetting, zonesSetting])

  return (
    <MapContext.Provider
      value={{
        locations,
        setLocations,
        mapCoords,
        setMapCoords,
        featuredMarker,
        setFeaturedMarker,
        mapFocus,
        setMapFocus,
        routeTarget,
        setRouteTarget,
        isRouteReady,
        setIsRouteReady,
        panelStatus: showPanel,
        setPanelStatus: setShowPanel,
        listLayout,
        setListLayout,
        searchFilter,
        setSearchFilter,
        accessSetting,
        setAccessSetting,
        servicesSetting,
        setServicesSetting,
        currentLocation,
        setCurrentLocation,
        showSettings,
        setShowSettings,
        scenariesSetting,
        setScenariesSetting,
        setZonesSetting,
        zonesSetting,
      }}
    >
      {children}
    </MapContext.Provider>
  )
}

export default MapProvider
